<template>
    <div class="navigation">
        <app-nav></app-nav>
    </div>
</template>

<script>
import nav from './Nav.vue'

export default {
    components: {
        'app-nav': nav
    }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/nav/Index.vue